import React from 'react'
import Icon from 'components/Icon'
import { observer } from 'mobx-react'
import styles from './PrimaryControls.sass'

interface PrimaryControlsProps {
  value: string
  onChange: (val: string) => void
  actions: React.ReactNode
}

export default observer(function PrimaryControls({
  value,
  onChange,
  actions,
}: PrimaryControlsProps) {
  const change = React.useCallback(
    (e: any) => {
      onChange(e.target.value)
    },
    [onChange],
  )

  return (
    <div className={styles.primaryControls}>
      <div className={styles.search}>
        <Icon name="search" />
        <input
          type="text"
          value={value}
          placeholder="Search"
          className={styles.searchInput}
          data-test="job-search-field"
          onChange={change}
        />
      </div>
      <div className={styles.actions}>{actions}</div>
    </div>
  )
})
